
export default class ConversationHintEvent {
    constructor(type, hint) {
        this._type = type;

        this._hint = hint;
    }

    get type() {
        return this._type;
    }

    get hint() {
        return this._hint;
    }
}

ConversationHintEvent.PERFORM = "ConversationHintEvent.PERFORM";